"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createValidator;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function createValidator(rules) {
  var join = function join(rules) {
    return function (value, data) {
      return rules.map(function (rule) {
        return rule(value, data);
      }).filter(function (error) {
        return !!error;
      })[0];
    };
  };

  var validateRule = function validateRule(ruleValue, data, key) {
    var ruleData = data || {}; // concat enables both functions and arrays of functions

    var rule = join([].concat(ruleValue));
    return rule(ruleData[key], ruleData);
  };

  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var errors = {};
    Object.keys(rules).forEach(function (key) {
      var ruleValue = rules[key];

      if (_typeof(ruleValue) === 'object' && !Array.isArray(ruleValue)) {
        Object.keys(ruleValue).forEach(function (subkey) {
          var error = validateRule(ruleValue[subkey], data[key], subkey);

          if (error) {
            errors[key] = errors[key] || {};
            errors[key][subkey] = error;
          }
        });
      } else {
        var error = validateRule(ruleValue, data, key);

        if (error) {
          errors[key] = error;
        }
      }
    });
    return errors;
  };
}